import Vue from 'vue'
import { Multipane, MultipaneResizer } from 'vue-multipane'

Vue.component('Multipane', Multipane)
Vue.component('MultipaneResizer', MultipaneResizer)
